import * as types from "../constants";

const initialState = {
  isLoading: true,
  error: null,
  items: [],
  requestParameters: {},
};

export default function documentsByMonthReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_DOCUMENTS_BY_MONTH_INIT:
      return { ...state, error: null, isLoading: true };

    case types.GET_DOCUMENTS_BY_MONTH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        items: action.data.data,
        requestParameters: action.data.requestParameters,
      };

    case types.GET_DOCUMENTS_BY_MONTH_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.notification.system_message,
      };

    default:
      return state;
  }
}
